import { ArrowDown } from 'lucide-react';
import { formatEuro, type ContactFinancingState, type ContactListSort } from '@brimo/shared';
import { Icon, Pill, type PillVariant } from '../../ds/components';
import styles from './ContactsPage.module.css';

/** „Finanzierbar“ column of Kontakte 01 (Paul feedback 02.11.2026, D-381): one compact pill per state. */

export function financingPill(
  state: ContactFinancingState,
  volumeUsedCents: number | null,
): { label: string; variant: PillVariant } | null {
  switch (state) {
    case 'calculated':
      return volumeUsedCents === null ? null : { label: formatEuro(volumeUsedCents), variant: 'success' };
    case 'returned':
      return { label: 'nicht berechnet', variant: 'warning' };
    case 'expired':
      return { label: 'abgelaufen', variant: 'neutral' };
    case 'sent':
      return { label: 'SA versendet', variant: 'info' };
    case 'none':
      return null;
  }
}

export function FinancingCell({
  state,
  volumeUsedCents,
}: {
  state: ContactFinancingState;
  volumeUsedCents: number | null;
}) {
  const pill = financingPill(state, volumeUsedCents);
  if (pill === null) return <span className={styles.muted}>—</span>;
  return <Pill variant={pill.variant}>{pill.label}</Pill>;
}

/** Header click: highest financeable volume first; a second click returns to the name order. */
export function toggleFinancingSort(sort: ContactListSort): ContactListSort {
  return sort === 'financing' ? 'name' : 'financing';
}

export function FinancingHeader({
  sort,
  onSort,
}: {
  sort: ContactListSort;
  onSort: (next: ContactListSort) => void;
}) {
  const active = sort === 'financing';
  return (
    <button
      type="button"
      className={styles.sortHeader}
      title={active ? 'Nach Name sortieren' : 'Höchstes Volumen zuerst'}
      onClick={() => onSort(toggleFinancingSort(sort))}
    >
      Finanzierbar
      {active ? <Icon icon={ArrowDown} size={16} /> : null}
    </button>
  );
}
